import axios from 'axios';
import { store } from 'Store/store.index';
import { PHANTOMONLINE_GLOBAL_CONFIG, URL_PLATFORM } from './constants';
import { updateProp } from '@/utils/utils';

// const convertApis = [
//   'platform/api/doc', 'platform/api/doc/convert', 'platform/api/task',
//   // share
//   '/cpdfapi/v1/share-review/participant',
//   '/cpdfapi/v1/share-review/list'
// ]

// const isConvertApi = (requestUrl) => {
//   let has = convertApis.some((uri) => {
//     return requestUrl.indexOf(uri) !== -1;
//   })
//   return has;
// }

export const interceptorsFn = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    function(response) {
      if (!window.__online__) {
        updateProp(window, '__online__', true);
        store.appStore.setisOnline(true);
      }
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      if (response && response.data) {
        if (response.data.ret === void 0 &&
          (response.data.code !== void 0 && response.data.code !== 0)) {
          response.data.ret = response.data.code === 100000
            ? 0
            : response.data.code;
        }
        if (response.data.message === void 0 && response.data.msg !== void 0) {
          response.data.message = response.data.msg;
        }
        let ret = response.data.ret;
        let url = window[PHANTOMONLINE_GLOBAL_CONFIG]
          ? window[PHANTOMONLINE_GLOBAL_CONFIG][URL_PLATFORM]
          : '';
        let baseURL = response.config.baseURL;
        if (((ret === 100010 || ret === 100011) && url &&
            baseURL.indexOf(url) !== -1)
          || ret === 210007) {
          store.appStore.doNotifyErrors(100010);
        }
        //response.data.header = response.header
        return response.data;
      }
      return response;
    },
    function(error) {
      console.error('TCL: ConvertApis -> initialize -> error', error);
      do {
        if (error.response && error.response.status === 401) {
          store.appStore.doNotifyErrors(100010);
          break;
        }
        if (!error.config || !error.config.url
          || !window[PHANTOMONLINE_GLOBAL_CONFIG] ||
          !window[PHANTOMONLINE_GLOBAL_CONFIG][URL_PLATFORM]) {
          break;
        }

        //let requestUrl = error.config.url;
        /* let platformUrl = window[PHANTOMONLINE_GLOBAL_CONFIG][URL_PLATFORM];
        if (requestUrl.indexOf(platformUrl) === -1) {
          break;
        } */
        if (error.message === 'Network Error' || !navigator.onLine ||
          !window.__online__) {
          //let has = isConvertApi(requestUrl);
          if (window.__online__) {
            updateProp(window, '__online__', false);
            store.appStore.setisOnline(false);
            store.appStore.doNotifyErrors('offline');
          }
          /* if (has) {
          } */
        }
      } while (false);
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    },
  );
};

export class HttpRequest {
  constructor() {
    /** @type {axios} */
    this.axiosClient = null;

    this.initialize = this.initialize.bind(this);
    this.interceptorsFn = this.interceptorsFn.bind(this);
    this.get = this.get.bind(this);
    this.post = this.post.bind(this);
    this.put = this.put.bind(this);
    this.patch = this.patch.bind(this);
    this.delete = this.delete.bind(this);
    this.getCancelSource = this.getCancelSource.bind(this);
  }

  isInit() {
    return !!this.axiosClient;
  }

  initialize(axiosInstance, callback) {
    this.axiosClient = axiosInstance;
    callback && callback();
  }

  /**
   * @returns {{token:String, cancel:Function}}
   * @memberof HttpRequest
   */
  getCancelSource() {
    const source = axios.CancelToken.source();
    return source;
  }

  interceptorsFn() {
    interceptorsFn(this.axiosClient);
  }

  interceptorsProxyFn(requestConfig, responseConfig) {
    requestConfig &&
    this.axiosClient.interceptors.request.use(requestConfig.success,
      requestConfig.error);
    responseConfig &&
    this.axiosClient.interceptors.response.use(responseConfig.success,
      responseConfig.error);
  }

  get({ url, /* msg = 'Interface exception', */ config, errCallback }) {
    let client = this.axiosClient;
    if (!client && url.indexOf('http') === 0) {
      console.error('axiosClient init error, to request "get" method');
      client = axios;
    }
    if (!client) {
      throw new Error('axiosClient init error, get request url:' + url);
    }
    // TODO foxit fw这里加入判断，如果IAM TOKEN存在，header里面塞入auth参数)
    if (store.loginNewStore.IAMToken) {
      if( config ) {
        if(config.headers) {
          config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        } else {
          config.headers = {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      } else {
        config = {
          headers: {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      }
    }
    return client.get(url, config).then((result) => {
      return result;
    }).catch(err => {
      errCallback && errCallback(err);
      throw err;
    });
  }

  post({ url, data, /* msg = 'Interface exception', */ config }) {
    let client = this.axiosClient;
    if (!client && url.indexOf('http') === 0) {
      console.error('axiosClient init error, to request "post" method');
      client = axios;
    }
    if (!client) {
      throw new Error('axiosClient init error, post request url:' + url);
    }
    // TODO foxit fw这里加入判断，如果IAM TOKEN存在，header里面塞入auth参数
    if (store.loginNewStore.IAMToken) {
      if( config ) {
        if(config.headers) {
          config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        } else {
          config.headers = {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      } else {
        config = {
          headers: {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      }
    }
    return client.post(url, data, config).then((result) => {
      return result;
    }).catch(err => {
      throw err;
    });
  }

  patch({ url, data, config }) {
    let client = this.axiosClient;
    if (!client && url.indexOf('http') === 0) {
      console.error('axiosClient init error, to request "patch" method');
      client = axios;
    }
    if (!client) {
      throw new Error('axiosClient init error, patch request url:' + url);
    }
    // TODO foxit fw这里加入判断，如果IAM TOKEN存在，header里面塞入auth参数
    if (store.loginNewStore.IAMToken) {
      if( config ) {
        if(config.headers) {
          config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        } else {
          config.headers = {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      } else {
        config = {
          headers: {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      }
    }
    return client.patch(url, data, config).then((result) => {

      return result;
    }).catch(err => {

      throw err;
    });
  }

  put({ url, data, /* msg = 'Interface exception', */ config }) {
    let client = this.axiosClient;
    if (!client && url.indexOf('http') === 0) {
      console.error('axiosClient init error, to request "put" method');
      client = axios;
    }
    if (!client) {
      throw new Error('axiosClient init error, put request url:' + url);
    }
    // TODO foxit fw这里加入判断，如果IAM TOKEN存在，header里面塞入auth参数
    if (store.loginNewStore.IAMToken) {
      if( config ) {
        if(config.headers) {
          config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        } else {
          config.headers = {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      } else {
        config = {
          headers: {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      }
    }
    return client.put(url, data, config).then((result) => {

      return result;
    }).catch(err => {

      throw err;
    });
  }

  delete({ url, config }) {
    let client = this.axiosClient;
    if (!client && url.indexOf('http') === 0) {
      console.error('axiosClient init error, to request "delete" method');
      client = axios;
    }
    if (!client) {
      throw new Error('axiosClient init error, delete request url:' + url);
    }
    // TODO foxit fw这里加入判断，如果IAM TOKEN存在，header里面塞入auth参数
    if (store.loginNewStore.IAMToken) {
      if( config ) {
        if(config.headers) {
          config.headers = {...config.headers, Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        } else {
          config.headers = {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      } else {
        config = {
          headers: {Authorization: `Bearer ${store.loginNewStore.IAMToken}`}
        }
      }
    }
    return client.delete(url, config).then((result) => {
      return result;
    }).catch(err => {

      throw err;
    });
  }
}

